import { ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";

export interface UserSummaryData {
    "360":                     The360;
    evaluated_id:              string;
    leadership:                The360;
    free:                      The360;
    summary_senior_management: string;
}

export interface The360 {
    bullet_points:        BulletPoint[];
    summary_line_manager: string;
}

export interface BulletPoint {
    reviewer_id:      string;
    reviewer:         Reviewer | null;
    text:             string;
    category_culture: string;
    category_praise:  CategoryPraise;
    process_type?:OriginProcessType;//infered from the processType of the parent object
}

export enum OriginProcessType{
    ThreeSixtyEvaluation = "ThreeSixtyEvaluation",
    FreeEvaluation = "FreeEvaluation",
    Leadership = "Leadership",
}

export enum CategoryPraise {
    Critica = "Crítica",
    Elogio = "Elogio",
}

export interface Reviewer {
    imageUrl:       string;
    name:           string;
    rank:           string;
    businessGroup:  string;
    businessUnit:   string;
    employeeNumber: number;
}